import { NgModule } from '@angular/core';
import { MODULE_DECLARATIONS, MODULE_PROVIDERS, MODULE_IMPORTS, MODULE_EXPORTS, MODULE_ENTRY_COMPONENTS } from './module-common';

@NgModule({
  declarations: MODULE_DECLARATIONS,
  providers: MODULE_PROVIDERS,
  imports: MODULE_IMPORTS,
  exports: MODULE_EXPORTS,
  entryComponents: MODULE_ENTRY_COMPONENTS
})
export class BusinessNavModule { }
